import { cloneDeep } from "lodash";
import React, { useState } from "react";
import AppButton from "../../common/AppButton";
import AppInput from "../../common/AppInput";
import numberFormat from "../../common/numberFormat";
import api from "../../config/api";
import colors from "../../config/colors";
import config from "../../config/config";
import { Modal } from "react-bootstrap";
import { MdMenu } from "react-icons/md";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";

const size = config.iconSize;

const formInit = {
  date: new Date(),
  amount: "",
  comment: "",
  employee: "",
};
export default function EmployeePaySalary() {
  const [disabled, setDisabled] = useState(false);
  const queryClient = useQueryClient();

  const Body = ({ employee, onDone }) => {
    const [form, setForm] = useState(cloneDeep(formInit));
    const handleChange = ({ target }) => {
      const name = target.name;
      const value = target.value;
      setForm({ ...form, [name]: value });
    };
    const handleSubmit = async (event) => {
      event.preventDefault();

      setDisabled(true);
      const res = await api.post("salary", {
        ...form,
        employee,
      });

      if (!res.ok) {
        setDisabled(false);
        toast.error(res.originalError.message);
      }
      queryClient.invalidateQueries(["salary"]);

      setForm(formInit);
      setDisabled(false);
      toast.success("Salary has been successfully paid.");

      onDone && onDone();
    };
    return (
      <form id="form" onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <span className="d-flex" style={{ alignItems: "center" }}>
            <MdMenu
              size={size}
              color={colors.silver}
              style={{ marginRight: 5 }}
            />
            <b>Pay Salary - {employee.name}</b>
          </span>
        </Modal.Header>
        <div
          className="d-flex"
          style={{
            gap: "0px 30px",
            padding: "0px 30px",
            // minHeight: 400,
            alignItems: "flex-start",
          }}
        >
          <AppInput
            type="date"
            name="date"
            placeholder="Date"
            label="Date"
            floatLabel
            value={form.date}
            onChange={handleChange}
            required
          />

          <AppInput
            name="amount"
            value={numberFormat(form.amount)}
            onChange={handleChange}
            required
            label="Amount"
            floatLabel
            containerStyle={{ height: 90 }}
          />
          <AppInput
            name="comment"
            value={form.comment}
            onChange={handleChange}
            required
            label="Comment"
            floatLabel
            containerStyle={{ height: 90 }}
          />
        </div>
        <Modal.Footer>
          <AppButton
            disabled={disabled}
            text="Pay Salary"
            form="form"
            type="submit"
            className="text-primary btn-light"
          />
        </Modal.Footer>
      </form>
    );
  };

  return { Body };
}
